import { render, staticRenderFns } from "./GeneralFormTab.vue?vue&type=template&id=324df25c"
import script from "./GeneralFormTab.vue?vue&type=script&lang=js"
export * from "./GeneralFormTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralFormTab.vue?vue&type=style&index=0&id=324df25c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports